export default class LiftoffAnimation {
  /** @type {Phaser.Scene} */
  scene;

  /** @type {Phaser.Physics.Arcade.Sprite} */
  plane;

  animationCompleted = false;

  /**
   *
   * @param {Phaser.Scene} scene
   * @param {Phaser.Physics.Arcade.Sprite} plane
   */
  constructor(scene, plane) {
    this.scene = scene;
    this.plane = plane;
  }

  start() {
    this.plane.setAcceleration(10, -this.scene.physics.world.gravity.y);
  }

  onCompleted() {
    return this.animationCompleted;
  }

  update() {
    if (this.plane.body.velocity.x >= 40 && this.plane.body.velocity.x <= 90)
      this.plane.setAngle((this.plane.body.velocity.x - 40) * 0.4 - 10);
    else if (
      this.plane.body.velocity.x >= 99.6 &&
      this.plane.body.velocity.y >= -100
    ) {
      this.plane.setAcceleration(0, -20);
      this.plane.setAngle(this.plane.body.velocity.y / 2 + 10);
    } else if (this.plane.y <= this.scene.scale.height / 2 + 250) {
      this.animationCompleted = true;
    }
  }
}
